// extracted by mini-css-extract-plugin
module.exports =  {"root":"Rj7xMFS5HjU_6gP45BOq"};